import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Heading } from 'wt-ui';

import VariationContext from '../../services/VariationContext';
import variations from '../../services/variations';

import DatePicker from '../../components/DatePicker';
import SearchInput from '../../components/SearchInput';

const Header = ({ dispatch, filters, fundList }) => {
  const variation = useContext(VariationContext);

  if (variation === variations.embedded) {
    return (
      <>
        <Box background="transparent">
          <Heading level={2}>Daily Performance</Heading>
        </Box>
      </>
    );
  }
  return (
    <>
      <Box background="transparent" direction="row-responsive" justify="between" gap="small">
        {variation === variations.standalone ? <SearchInput fundList={fundList} dispatch={dispatch} /> : ''}
        <DatePicker {...filters} dispatch={dispatch} />
      </Box>
    </>
  );
};

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filters: PropTypes.shape({}).isRequired,
  fundList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Header;
